import { serializeError } from 'serialize-error'

import { redactPiiFromObj } from '@lib/utils/pii'

const serializeErrorObjSafe = <T>(error: T) => {
  return redactPiiFromObj(serializeError(error))
}

export const transformToString = <T extends object>(error: T): string => {
  return JSON.stringify(serializeErrorObjSafe(error))
}

export const transformToObject = <T extends object>(error: T): object => {
  return serializeErrorObjSafe(error)
}
